module.exports = __webpack_public_path__ + "static/suite-301-2-7994e3161e63e854149b1ce75d22fb61.jpg";